import { html } from "lit";
var icon_start_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M19.872 14.705l-.056.133-6 13c-.712 1.543-2.875 1.537-3.605.058l-.068-.153-1.278-3.194-5.158 5.158a1 1 0 01-1.497-1.32l.083-.094 5.158-5.16-3.194-1.276c-1.524-.61-1.675-2.65-.383-3.512l.139-.085.149-.076 13-6c1.644-.759 3.341.876 2.71 2.52zM18 14L5 20l5 2 2 5 6-13zm7.744 6.328l3.963 3.965a1 1 0 01-1.327 1.492l-.087-.078-3.965-3.963a10.08 10.08 0 001.416-1.416zM18 6a8 8 0 01.728 15.967l1.03-2.229a6.002 6.002 0 10-7.497-7.495l-2.228 1.03A8 8 0 0118 6zm9.95 6.999L30 13a1 1 0 01.117 1.993L30 15h-2.05a10.008 10.008 0 000-2.001zM7.62 2.215l.087.078 3.965 3.963a10.08 10.08 0 00-1.416 1.416L6.293 3.707A1 1 0 017.62 2.215zm22.087.078a1 1 0 01.078 1.327l-.078.087-3.963 3.965a10.08 10.08 0 00-1.416-1.416l3.965-3.963a1 1 0 011.414 0zM18 1a1 1 0 01.993.883L19 4.05a10.039 10.039 0 00-2 0V2a1 1 0 011-1z" />
  </svg>
`;
export {
  icon_start_default as default
};
//# sourceMappingURL=icon-start.js.map
